import apiClient from '@/services/axios'

// Returns an object like:
// {
//   timestamp: 1714766400000,
//   checked: [{ id, name }...],
//   unchecked: [{ id, name }...],
//   percentChecked: 42
// }
export function getAttendanceSnapshot(params = {}) {
  return apiClient.get('/attendance/snapshot', { params })
}

// Optional: stream or poll endpoint for live updates
export function getAttendanceHistory(params = {}) {
  return apiClient.get('/attendance/history', { params })
}

// Get count of late employees in the last 15 minutes
// Returns: { count: number, message: string }
// Org scope comes from the JWT on the backend. Do NOT send a client-side
// organizationId: for routr_team users the guard passes it through, and the
// stale localStorage value showed ANOTHER org's attendance (Matt's demo 9/16).
export function getLateCount() {
  return apiClient.get('/employees/attendance/late-count')
}

// Get attendance log for a specific date (org scope from the JWT, see above)
// Returns array of attendance records
export function getAttendanceLog(date) {
  return apiClient.get('/employees/attendance/log', {
    params: { date },
  })
}


